module.exports = __webpack_public_path__ + "static/img/info_3.76c9779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2023/info_3.jpg
// module id = whYG
// module chunks = 4